import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-column gap-3" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = { class: "flex gap-1 p-2 border-1 border-300 border-round-xl w-fit h-fit text-base" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "font-semibold text-primary" }
const _hoisted_6 = { class: "text-600 mb-0" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "font-semibold text-primary" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "font-semibold text-primary" }
const _hoisted_11 = {
  key: 3,
  class: "text-600 text-base"
}
const _hoisted_12 = {
  key: 4,
  class: "flex align-items-center gap-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "•", -1)
const _hoisted_14 = { class: "flex flex-column text-base gap-3" }
const _hoisted_15 = { class: "text-primary font-semibold text-right" }
const _hoisted_16 = { class: "flex gap-1" }
const _hoisted_17 = { class: "text-600" }
const _hoisted_18 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconChevronRight = _resolveComponent("IconChevronRight")!
  const _component_IconBike = _resolveComponent("IconBike")!
  const _component_IconLock = _resolveComponent("IconLock")!

  return (_openBlock(), _createElementBlock("button", {
    class: "plainButton flex w-full gap-3 justify-content-between cursor-pointer text-left px-0",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleRouteSelection(_ctx.route)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.route.legs, (leg, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex gap-1 align-items-center"
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIconComponent(leg.mode))))
            ]),
            (index !== _ctx.route.legs.length - 1)
              ? (_openBlock(), _createBlock(_component_IconChevronRight, {
                  key: 0,
                  class: "text-sm text-600"
                }))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (_ctx.hasBusInfo)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t("route_planner.from")) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.hasBusInfo?.start.station?.name), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("route_planner.at")) + " " + _toDisplayString(_ctx.formatTime(_ctx.hasBusInfo?.startTime)), 1)
          ]))
        : (_ctx.hasBikeInfo)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$t("route_planner.from")) + " ", 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.bikeStartLocation?.name), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.$t("route_planner.to")) + " ", 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.endLocationString), 1)
            ])),
      (_ctx.hasBikeInfo)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("route_planner.with_bike")), 1))
        : _createCommentVNode("", true),
      (_ctx.hasBikeInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_IconBike, { class: "text-primary" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.bikeInfo()?.availableVehicles), 1),
            _hoisted_13,
            _createVNode(_component_IconLock, { class: "text-primary" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.bikeInfo()?.availableSpaces), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getDuration(_ctx.route)), 1),
      _createElementVNode("span", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.timeModeSelection === "departure"
            ? _ctx.$t("route_planner.arrival")
            : _ctx.$t("route_planner.departure")), 1),
        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.timeModeSelection === "departure"
            ? _ctx.getArrivalTime(_ctx.route)
            : _ctx.getDepartureTime(_ctx.route)), 1)
      ])
    ])
  ]))
}